/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type projectList_viewer$ref: FragmentReference;
export type projectList_viewer = {|
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +$refType: projectList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "projectList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "projects",
      "storageKey": "projects(first:100,scope:\"CurrentUser\")",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "scope",
          "value": "CurrentUser",
          "type": "QueryScopeEnumType!"
        }
      ],
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_public",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": "tracks",
                  "name": "__project_tracks_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectTrackConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ProjectTrackEdge",
                      "plural": true,
                      "selections": [
                        v0,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "cursor",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TrackSearchResult",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "__typename",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "pageInfo",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "endCursor",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "hasNextPage",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "owner",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectUser",
                  "plural": false,
                  "selections": [
                    v0,
                    v1,
                    v2,
                    v3
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "users",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectUser",
                  "plural": true,
                  "selections": [
                    v0,
                    v1,
                    v2,
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "role",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "license_params",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LicenseUsageParams",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "spot_count",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "term",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "medium",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contextual_param",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contextual_param_type",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = '9d73deb81e95b0ab23f969d1dd14042f';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/projectList_viewer.graphql.js